<template>
	<transition
			name="custom-classes-transition"
			:enter-active-class="$_scbLst_styleComponentAnimation()">
		<template v-if="$_scbLst_stateComponentIsInitialized">
			<v-list class="customVList" 
					expand
					:color="$_scbLst_styleListColor"
					:dark="$_scbLst_styleListDark"
					:dense="$_scbLst_styleListDense"
					:elevation="$_scbLst_styleListElevation"
					:flat="$_scbLst_styleListFlat"
					:light="$_scbLst_styleListLight"
					:nav="$_scbLst_styleListNav"
					:rounded="$_scbLst_styleListRounded"
					:shaped="$_scbLst_styleListShaped"
					:subheader="$_scbLst_styleListSubheader"
					:three-line="$_scbLst_styleListThreeLine"
					:tile="$_scbLst_styleListTile"
					:two-line="$_scbLst_styleListTwoLine">
				<v-list-group 
						v-model="isOpened_"
						no-action>
					<template v-slot:activator>
						<v-row no-gutters>
							<v-col>
								<v-subheader 
										class="caption"
										v-html="$_scbLst_langTitle" />
							</v-col>
						</v-row>
					</template>
					<!-- start date -->
					<v-list-item class="customVListItem" dense>
						<v-menu	v-model="showStartDate_"
								:close-on-content-click="false">
							<template v-slot:activator="{ on }">
								<v-text-field 
										class="customVTextField"

										v-model="startDate_"
								
										hide-details
										prepend-inner-icon="event"
										single-line

										:background-color="$_scbLst_styleTextFieldBackgroundColor"
										:clearable="$_scbLst_styleTextFieldClearable"
										:color="$_scbLst_styleTextFieldColor"
										:counter="$_scbLst_styleTextFieldCounter"
										:dark="$_scbLst_styleTextFieldDark"
										:filled="$_scbLst_styleTextFieldFilled"
										:flat="$_scbLst_styleTextFieldFlat"
										:light="$_scbLst_styleTextFieldLight"
										:outlined="$_scbLst_styleTextFieldOutlined"
										:solo="$_scbLst_styleTextFieldSolo"
										:solo-inverted="$_scbLst_styleTextFieldSoloInverted"

										:label="$_scbLst_langStartDate"

										v-on="on" />
							</template>
							<v-date-picker
									v-model="startDate_"
									@change="showStartDate_ = false" />
						</v-menu>
					</v-list-item>
					<!-- end date -->
					<v-list-item class="customVListItem" dense>
						<v-menu	v-model="showEndDate_"
								:close-on-content-click="false">
							<template v-slot:activator="{ on }">
								<v-text-field
										class="customVTextField"

										v-model="endDate_"
								
										hide-details
										prepend-inner-icon="event"
										single-line

										:background-color="$_scbLst_styleTextFieldBackgroundColor"
										:clearable="$_scbLst_styleTextFieldClearable"
										:color="$_scbLst_styleTextFieldColor"
										:counter="$_scbLst_styleTextFieldCounter"
										:dark="$_scbLst_styleTextFieldDark"
										:filled="$_scbLst_styleTextFieldFilled"
										:flat="$_scbLst_styleTextFieldFlat"
										:light="$_scbLst_styleTextFieldLight"
										:outlined="$_scbLst_styleTextFieldOutlined"
										:solo="$_scbLst_styleTextFieldSolo"
										:solo-inverted="$_scbLst_styleTextFieldSoloInverted"

										:label="$_scbLst_langEndDate"
										
										v-on="on" />
							</template>
							<v-date-picker 
									v-model="endDate_"
									@change="showEndDate_ = false" />
						</v-menu>
					</v-list-item>
					<!-- search word -->
					<v-list-item class="customVListItem" dense>
						<v-text-field 
								class="customVTextField"

								v-model="word_"

								hide-details
								prepend-inner-icon="search"
								single-line

								:background-color="$_scbLst_styleTextFieldBackgroundColor"
								:clearable="$_scbLst_styleTextFieldClearable"
								:color="$_scbLst_styleTextFieldColor"
								:counter="$_scbLst_styleTextFieldCounter"
								:dark="$_scbLst_styleTextFieldDark"
								:filled="$_scbLst_styleTextFieldFilled"
								:flat="$_scbLst_styleTextFieldFlat"
								:light="$_scbLst_styleTextFieldLight"
								:outlined="$_scbLst_styleTextFieldOutlined"
								:solo="$_scbLst_styleTextFieldSolo"
								:solo-inverted="$_scbLst_styleTextFieldSoloInverted"

								:label="$_scbLst_langSearchWord" />
					</v-list-item>
					<!-- search tag -->
					<v-list-item class="customVListItem" dense>
						<v-text-field 
								class="customVTextField"

								v-model="tag_"

								hide-details
								prepend-inner-icon="search"
								single-line

								:background-color="$_scbLst_styleTextFieldBackgroundColor"
								:clearable="$_scbLst_styleTextFieldClearable"
								:color="$_scbLst_styleTextFieldColor"
								:counter="$_scbLst_styleTextFieldCounter"
								:dark="$_scbLst_styleTextFieldDark"
								:filled="$_scbLst_styleTextFieldFilled"
								:flat="$_scbLst_styleTextFieldFlat"
								:light="$_scbLst_styleTextFieldLight"
								:outlined="$_scbLst_styleTextFieldOutlined"
								:solo="$_scbLst_styleTextFieldSolo"
								:solo-inverted="$_scbLst_styleTextFieldSoloInverted"

								:label="$_scbLst_langSearchTag" />
					</v-list-item>
					<!-- search button -->
					<v-list-item class="customVListItem">
						<v-btn	class="customVBtn"
								:block="$_scbLst_styleSearchButtonBlock"
								:color="$_scbLst_styleSearchButtonColor"
								:dark="$_scbLst_styleSearchButtonDark"
								:depressed="$_scbLst_styleSearchButtonDepressed"
								:elevation="$_scbLst_styleSearchButtonElevation"
								:large="$_scbLst_styleSearchButtonLarge"
								:light="$_scbLst_styleSearchButtonLight"
								:outlined="$_scbLst_styleSearchButtonOutlined"
								:rounded="$_scbLst_styleSearchButtonRounded"
								:small="$_scbLst_styleSearchButtonSmall"
								:text="$_scbLst_styleSearchButtonFlat"
								@click="$_scbLst_search()"
								v-text="$_scbLst_langSearchButton" />
					</v-list-item>
				</v-list-group>
			</v-list>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'SearchbarList',
		data() {
			return {
				componentName_: 'searchbarList',

				isOpened_: true,

				showStartDate_: false,
				showEndDate_: false,

				startDate_: null,
				endDate_: null,
				word_: null,
				tag_: null,

				componentState_: {}
			}
		},
		computed: {
			// state
			$_scbLst_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_scbLst_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_scbLst_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_scbLst_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			$_scbLst_langTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_scbLst_inits(), 'title')
				return self_.getLangsVal(lang_)
			},
			$_scbLst_langStartDate() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_scbLst_inits(), 'startDate')
				return self_.getLangsVal(lang_)
			},
			$_scbLst_langEndDate() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_scbLst_inits(), 'endDate')
				return self_.getLangsVal(lang_)
			},
			$_scbLst_langSearchWord() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_scbLst_inits(), 'searchWord')
				return self_.getLangsVal(lang_)
			},
			$_scbLst_langSearchTag() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_scbLst_inits(), 'searchTag')
				return self_.getLangsVal(lang_)
			},
			$_scbLst_langSearchButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_scbLst_inits(), 'searchButton')
				return self_.getLangsVal(lang_)
			},
			// style
			$_scbLst_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_scbLst_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_scbLst_inits(), 'component')
				}
			},
			$_scbLst_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_scbLst_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_scbLst_styleList() {
				const self_ = this;
				if(self_.isEmpty(self_.$_scbLst_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_scbLst_inits(), 'list')
			},
			$_scbLst_styleListColor() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.color)
			},
			$_scbLst_styleListDark() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dark)
			},
			$_scbLst_styleListDense() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dense)
			},
			$_scbLst_styleListElevation() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.elevation)
			},
			$_scbLst_styleListFlat() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.flat)
			},
			$_scbLst_styleListLight() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.light)
			},
			$_scbLst_styleListNav() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.nav)
			},
			$_scbLst_styleListRounded() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.rounded)
			},
			$_scbLst_styleListShaped() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.shaped)
			},
			$_scbLst_styleListSubheader() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.subheader)
			},
			$_scbLst_styleListThreeLine() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.threeLine)
			},
			$_scbLst_styleListTile() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.tile)
			},
			$_scbLst_styleListTwoLine() {
				const self_ = this;
				const list_ = self_.$_scbLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.twoLine)
			},
			$_scbLst_styleSearchButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_scbLst_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_scbLst_inits(), 'searchButton')
			},
			$_scbLst_styleSearchButtonBlock() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.block)
			},
			$_scbLst_styleSearchButtonColor() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_scbLst_styleSearchButtonDark() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_scbLst_styleSearchButtonDepressed() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.depressed)
			},
			$_scbLst_styleSearchButtonElevation() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.elevation)
			},
			$_scbLst_styleSearchButtonFlat() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.large)
			},
			$_scbLst_styleSearchButtonLarge() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.large)
			},
			$_scbLst_styleSearchButtonLight() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_scbLst_styleSearchButtonOutlined() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_scbLst_styleSearchButtonRounded() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.rounded)
			},
			$_scbLst_styleSearchButtonSmall() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.small)
			},
			$_scbLst_styleSearchButtonText() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleSearchButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_scbLst_styleTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.$_scbLst_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_scbLst_inits(), 'textField')
			},
			$_scbLst_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_scbLst_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_scbLst_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_scbLst_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_scbLst_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_scbLst_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_scbLst_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_scbLst_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_scbLst_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_scbLst_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_scbLst_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_scbLst_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			}
		},
		beforeMount() {
			const self_ = this;
			
			self_.componentState_ = self_.getState('component')
		},
		methods: {
			$_scbLst_search(){
				const self_ = this;
				const router_ = self_.$router;

				const searchbarList_ = {
					startDate: self_.startDate_,
					endDate: self_.endDate_,
					word: self_.word_,
					tag: self_.tag_
				}

				self_.setComponentState('searchbarList', searchbarList_)

				if(self_.$_scbLst_stateAppIsMobileScreen) {
					router_.push('/timeline/refresh')
				}
			}
		}
	}
</script>

<style scoped>
	.customVTextField {
		margin-top: 0;
		padding-top: 0;
	}
</style>